import Supports from './supports'
import SupportMessages from './messages'
import { useSelector } from 'react-redux'
import { StyleWrapper } from './style'
import { useLocation } from 'react-router-dom'
const HelpAndSupport = () => {
  const conversation = useSelector((state: any) => state.supportConversation)
  const { data: user } = useSelector((state: any) => state.user)
  const { state } = useLocation()
  const messageProps = {
    receiver: !!state?.receiver
      ? state?.receiver
      : !!conversation?.user1
        ? conversation?.user1
        : conversation?.user2,

    sender: {
      id: user?.role == 'admin' ? '0' : user?.id,
      name: user?.role == 'admin' ? 'Supachar Support' : user?.name,
      avatar: user?.role == 'admin' ? '' : user?.avatar,
    },
  }
  return (
    <StyleWrapper>
      <Supports {...messageProps} />
      <SupportMessages {...messageProps} />
    </StyleWrapper>
  )
}

export default HelpAndSupport
